import React, { useEffect, useState } from "react";
import Banner from "../../components/UserSideComponents/propertydetails/Banner";
import HostelInfo from "../../components/UserSideComponents/propertydetails/HostelInfo";
import SimilarPlace from "../../components/UserSideComponents/propertydetails/SimilarPlace";
import Room from "../../components/UserSideComponents/propertydetails/Room";
import { useParams } from "react-router-dom";
import axios from "axios";
import LinkTab from "../../components/UserSideComponents/propertyPage.jsx/HousingRule";
function PropertyDetails() {
  const [building, setBuilding] = useState({});

  const { slug } = useParams();
  console.log("slug: ", slug);

  const getBuildingById = () => {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/resources/get_building_by_slug/${slug}`,
      headers: {},
    };
    axios
      .request(config)
      .then((response) => {
        console.log("Response of getBuildingById: ", response.data);
        setBuilding(response.data.building);
      })
      .catch((error) => {
        console.log("Error in fetching the building by ID: ", error);
      });
  };

  useEffect(() => {
    getBuildingById();
  }, [slug]);

  return (
    <div>
      {building?.images?.length > 0 ? (
        <>
          <Banner building={building} />
          <HostelInfo building={building} />
          <Room building={building} />
          <LinkTab title="House Rule" navigateTo="housing-rule" />
          <SimilarPlace />
        </>
      ) : (
        <div className="">Loading...</div>
      )}
    </div>
  );
}

export default PropertyDetails;
